export default "__VITE_ASSET__df9326f2__"